import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL + '/new_order/chat';
const options = {
    headers: {
        'Content-Type': 'multipart/form-data',
    }
};
let needleUrl;

function saveVersionRating(payload) {
    needleUrl = `${url}/save-version-rating`;
    return axios.post(needleUrl, payload.data)
        .then(response => {
            return {
                saveVersionRating: response.data
            };
        });
}

export default {
    saveVersionRating
};